import axios from 'axios';
import SecureLS from 'secure-ls';
import swal from "sweetalert";

const errorMap = {
    "jwt expired": "Your session is timed out, please login to continue"
}
const sendRequest = (endpoint, payload) => new Promise((resolve, reject) => {
    // console.log("sending request")
    const ls = new SecureLS();
    const data = ls.get('data');
    const access_token = data ? data.token : "";
    // console.log("token = ", access_token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

    axios.post(endpoint, payload).then((res) => {
        // console.log(res)
        // console.log("res.data = ", res.data)
        resolve(res.data);
    }).catch(err => {
        console.log("error: ", err.response);
        const msg = errorMap[err?.response?.data?.message] || err?.response?.data?.message;

        if (err?.response?.data?.message === "jwt expired") {
            swal("", "Your session is expired, Please login again to continue", "warning");
            localStorage.clear();
            setTimeout(() => {
                window.location.href = "/login";
            }, 2000)

        }
        reject(msg || "Something Went Wrong!!");
    })
});

export default sendRequest;